import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
// import { ChartistModule } from 'ng-chartist';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FormsModule } from '@angular/forms';
import { NgbModule, NgbDatepickerModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { BlockUIModule } from 'ng-block-ui';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { BlockTemplateComponent } from 'src/app/_layout/blockui/block-template.component';
import { BreadcrumbModule } from 'src/app/_layout/breadcrumb/breadcrumb.module';
import { CardModule } from '../../partials/general/card/card.module';
import { NgSelectModule } from '@ng-select/ng-select';
import{ AddquotationComponent} from '../quotation/addquotation/addquotation.component'
import{ AllquotationComponent} from '../quotation/allquotation/allquotation.component'
import { NgxSpinnerModule } from 'ngx-spinner';
import { CustomLoaderModule } from 'src/app/CustomLoader/custom-loader/custom-loader.module';
import { ViewquotationComponent } from './viewquotation/viewquotation.component';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { jsPDF } from "jspdf";

@NgModule({
  declarations: [AddquotationComponent, AllquotationComponent, ViewquotationComponent],
  imports: [
    CommonModule,
    CustomLoaderModule,
    // ChartistModule,
    FormsModule,
    CommonModule,
    NgSelectModule,
    NgxDatatableModule,
    AutocompleteLibModule,
    PerfectScrollbarModule,
    NgbModule,
    PdfViewerModule,
    // NgbDatepickerModule.forRoot(),
    // NgbDatepickerModule.forRoot(),
    // NgbModalModule.forRoot(),
    BreadcrumbModule,
    CardModule,
    BlockUIModule.forRoot({
      template: BlockTemplateComponent
    }),
    RouterModule.forChild([
      {
        path:"addquotation",
        component:AddquotationComponent
      
      },
      {
        path:"allquotation",
        component:AllquotationComponent      
      },
      {
        path:"viewquotation",
        component:ViewquotationComponent      
      },
     
    ]),
    NgxSpinnerModule
    
  ],

})
export class QuotationModule { }
